import { type MutationOptions, useMutation } from 'react-query'

import agent from 'agent'
import useAuth from 'hooks/use-auth'
import { clientsMutationKeys } from 'queries/clients/query-keys'
import { getEndpointWithParams } from 'queries/queries-utils'

function deleteClient([endpoint, params]: ReturnType<
  typeof clientsMutationKeys.delete
>) {
  return async () => {
    const endpointWithParams = getEndpointWithParams(endpoint, params)

    await agent.delete(endpointWithParams)
  }
}

export const useDeleteClients = (
  identifier: string,
  options?: Omit<MutationOptions, 'mutationKey' | 'mutationFn'>
) => {
  const { currentTeamId: teamId } = useAuth()

  const queryParams = {
    identifier,
    teamId
  }

  const mutationKey = clientsMutationKeys.delete(queryParams)

  return useMutation({
    ...options,
    mutationKey,
    mutationFn: deleteClient(mutationKey)
  })
}
